import {useDocumentTitle} from '@refinedev/react-router';
import {useTranslation} from 'react-i18next';

export const Home = () => {
  useDocumentTitle('documentTitle.pilotage-rh');
  const {t} = useTranslation();
  return (
    <div>
      <h1>{t('pages.pilotage-rh.dashboard.title')}</h1>
    </div>
  );
};
